import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { SearchClass, User } from '../model/user-profile';
import { DataService, IHttpCallBack } from 'projects/Shared-Lib/services/data.service';
import { NGXLogger } from 'ngx-logger';
import { ResultClass } from 'projects/Shared-Lib/model/search-result';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

@Injectable({
  providedIn: 'root'
})
export class UserProfileService extends DataService {
  controllerName = 'UserProfile';
  userUrl = this.BaseUrl + this.controllerName;
  myProfileUrl = this.BaseUrl + 'MyProfile';

  constructor(private httpClint: HttpClient, public logger: NGXLogger) {
    super(httpClint, logger);
  }

  /** Get Input (Located RO, Located Entity)Options. */
  public GetInputOptions(successCallback: IHttpCallBack, failCallback: IHttpCallBack = null, finalCallback: IHttpCallBack = null) {
    this.getData(this.controllerName + '/InitInputOptions', null, successCallback, failCallback, finalCallback);
  }

  /** GET all users. Will 404 if id not found */
  public GetInitData(successCallback: IHttpCallBack, failCallback: IHttpCallBack = null, finalCallback: IHttpCallBack = null) {
    this.getData(this.controllerName + '/init', null, successCallback, failCallback, finalCallback);
  }

  /** GET all users. Will 404 if id not found */
  public GetUsers(searchParameter: SearchClass): Observable<ResultClass> {
    let httpParams = new HttpParams();
    Object.keys(searchParameter).forEach(function (key) {
      httpParams = httpParams.append(key, searchParameter[key]);
    });
    return this.httpClint.get<ResultClass>(this.userUrl + '/List',
      { headers, params: httpParams })
      .pipe(
        catchError(this.pHandleError<ResultClass>(`GetUsers`))
      );//.subscribe(x => result = x);
  }

  /** GET user by id. Will 404 if id not found */
  GetUser(id: string): Observable<ResultClass> {
    const url = `${this.userUrl}/${id}`;
    return this.httpClint.get<ResultClass>(url)
      .pipe(
        //tap(data => console.log(data)),
        catchError(this.pHandleError<ResultClass>(`GetUser id=${id}`))
      );
  }

  GetCurrentUser(): Observable<ResultClass> {
    const url = `${this.myProfileUrl}`;
    return this.httpClint.get<ResultClass>(url)
      .pipe(
        //tap(data => console.log(data)),
        catchError(this.pHandleError<ResultClass>(`Get my profile`))
      );
  }

  /** GET: Get ADUser from api */
  GetADUser(searchParameter: any): Observable<ResultClass> {
    const url = this.BaseUrl + 'Login';
    let httpParams = new HttpParams();
    Object.keys(searchParameter).forEach(function (key) {
      httpParams = httpParams.append(key, searchParameter[key]);
    });

    //userAccount
    let token = localStorage.getItem('access_token');
    let localHeaders = new HttpHeaders({
      'Content-Type': 'application/json'
      , 'Authorization': token
    });

    return this.httpClint.get<ResultClass>(url,
      { headers: localHeaders, params: httpParams })
      .pipe(
        tap(data => this.logger.debug('UP4001', data)),
        //catchError(this.pHandleError<HttpResult>(`GetADUser id=${searchParameter}`))
      );
  }


  /** POST: add a new User to the server */
  AddUser(body: User): Observable<ResultClass> {
    return this.httpClint.post<ResultClass>(this.userUrl, body, httpOptions).pipe(
      tap(),
      catchError(this.pHandleError<ResultClass>('AddUser'))
    );
  }

  /** DELETE: delete the hero from the server */
  DeleteUser(id: string): Observable<ResultClass> {
    const url = `${this.userUrl}/${id}`;
    return this.httpClint.delete<ResultClass>(url, httpOptions).pipe(
      //tap(data => console.log(data)),
      //catchError(this.pHandleError<HttpResult>('DeleteUser'))
    );
  }

  /** PUT: update the hero on the server */
  UpdateUser(id: string, user: User): Observable<ResultClass> {
    const url = `${this.userUrl}/${id}`;
    return this.httpClint.put<ResultClass>(url, user, httpOptions).pipe(
      //tap(data => console.log(data)),
      //catchError(this.pHandleError<any>('UpdateUser'))
    );
  }


  /**
  * Handle Http operation that failed.
  * Let the app continue.
  * @param operation - name of the operation that failed
  * @param result - optional value to return as the observable result
  */
  private pHandleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      this.logger.debug('UP8001', 'user profile handle error: ' + error);
      if (error.error)
        // Let the app keep running by returning an empty result.
        return of(error.error as T);
      else
        return of(result as T);
    };
  }
}
